export default {"src":"/_next/static/media/customer.3d477edc.svg","height":33,"width":32};